import type {
    SubmitCommerceCheckoutRequest,
    SubmitCommerceCheckoutResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const submitCommerceCheckoutOperation = defineCommerceOperation<
    SubmitCommerceCheckoutRequest,
    SubmitCommerceCheckoutResponse
>("commerce.checkout.submit");
